import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserMd, faGraduationCap, faLanguage } from '@fortawesome/free-solid-svg-icons';
import './Doctors.css';

const Doctors = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [animatedRows, setAnimatedRows] = useState(new Set());
  const doctorsRef = useRef(null);
  const ctaRef = useRef(null);

  const mockDoctors = [
    {
      id: 'dr-ahmed-shetia',
      name: 'Dr. Ahmed Shetia',
      specialty: 'General Practitioner',
      qualifications: 'MBBS, FRACGP, Dip of Skin Cancer Medicine and Surgery. ED diploma ACEM, Msc Paediatric. Authorised prescriber for medicinal cannabis',
      image: '/images/DR-AHMED-SHETIA_flat-1.jpg',
      shortBio: 'With over 15 years of diverse medical experience across Egypt, Oman, and Australia, Dr. Shetia brings expertise in general practice, paediatrics, emergency medicine, and critical care.',
      fullBio: 'With over 15 years of diverse medical experience across Egypt, Oman, and Australia, I bring a broad clinical background in general practice, paediatrics, emergency medicine, and critical care. I completed Paediatric ICU training in Egypt and worked as a paediatrician before moving to Oman, where I served as a GP in one of the country\'s largest rural hospitals for three years. Since relocating to Australia in 2017, I have worked as an ICU registrar at Blacktown Hospital, followed by over three years as a medical and emergency registrar at Maitland and John Hunter Hospitals. I later held a senior emergency medicine role at Belmont Hospital for two years. Most recently, I completed my GP training over the past three years at a busy general practice clinic in Cessnock. I am fluent in both English and Arabic and am known for being compassionate, knowledgeable, and committed to long-term patient care. Outside of work, I enjoy reading, movies, bushwalking, and travelling with my family.',
      languages: ['English', 'Arabic'],
      specialInterests: ['Chronic Disease Management', 'Medicinal Cannabis', 'Mental Health', 'Anxiety and PTSD', 'Chronic Pain', 'Sleep Disorders'],
      availability: 'Mondays and Wednesdays',
      certifications: [
        'AMC Certificate',
        'Diploma in Advancing Emergency Medicine – ACEM',
        'TGA Authorised Prescriber Scheme (APS) – Medicinal Cannabis',
        'Professional Certificate in Skin Cancer Medicine',
        'Skin Cancer Cert, Dip of Skin Cancer Medicine and Surgery',
        'Dermoscopy Cert',
        'MSc Paediatric, Ainshams Uni, Egypt',
        'ALS1 & ALS2 (Advanced Life Support)',
        'Advanced Airway Management',
        'Advanced Injectable Iron and Vitamin Therapies'
      ]
    },
    {
      id: 'dr-mohammed',
      name: 'Dr. Mohammed Mohammed',
      specialty: 'General Practitioner',
      qualifications: 'MBBS Grad Cert. Clin. Ultrasound (Melb) FACRRM EM AST',
      image: '/images/Mohammed profile.jpg',
      shortBio: 'Dr Mohammed Mohammed holds Fellowship with ACRRM and has 10 years of experience as a doctor. His special interests include skin cancer surgery, point-of-care ultrasonography and pain management.',
      fullBio: 'Dr Mohammed Mohammed holds Fellowship with ACRRM and has 10 years of experience as a doctor. His other roles revolve around being a GP Supervisor and a Medical Educator whilst his special interests include skin cancer surgery, point-of-care ultrasonography and pain management. He is highly regarded amongst his peers for his professional approach and equally so amongst his patients as an attentive practitioner.',
      languages: ['English', 'Arabic', 'Kurdish'],
      specialInterests: ['Skin Cancer Surgery', 'Point-of-Care Ultrasonography', 'Pain Management', 'Medical Education'],
      availability: 'Every other Tuesday and Fridays'
    },
    {
      id: 'dr-shaimaa-elgayar',
      name: 'Dr. Shaimaa Elgayar',
      specialty: 'General Practitioner',
      qualifications: 'MBBS, FRACGP, RACGP Dermatology Cert, Dip of Skin Cancer Medicine and Surgery',
      image: '/images/shaimaa.jpg',
      shortBio: 'Dr. Shaimaa Elgayar is a GP specialist family physician and fellow of the RACGP with nearly two decades of international medical experience.',
      fullBio: 'Dr. Shaimaa Elgayar is a GP specialist family physician and fellow of the RACGP who is highly experienced medical professional with a diverse and international career spanning nearly two decades. Since earning her medical degree in 2004, she has practiced medicine across multiple countries, including Australia, where she has become a trusted and respected figure in general practitioners. Dr. Shaimaa has worked in various capacities as a Career Medical Officer (CMO) across different departments at local hospitals in Newcastle, Australia, including General Medicine and Medical Oncology at Calvary Mater Hospital, and Emergency Medicine at John Hunter Hospital and Tomaree Hospital. Her dermatology expertise, particularly in skin cancer, is complemented by an RACGP Certificate in Dermatology. Dr. Shaimaa has undergone advanced training in skin cancer surgeries, including techniques such as flaps and grafts, and is currently working toward full accreditation with the Skin Cancer College of Australia.',
      languages: ['English', 'Arabic', 'French'],
      specialInterests: ['Skin Cancer Medicine and Surgery', 'Aesthetic Medicine', 'Chronic Diseases', 'Mental Health', 'Women\'s Health', 'Medicinal Cannabis'],
      availability: 'Every other Teusdays and Thursdays',
      quote: 'True healing begins when we listen, understand, and treat each patient as a whole person—not just a condition.'
    },
    {
      id: 'dr-karan-sian',
      name: 'Dr. Karan Sian',
      specialty: 'GP Registrar',
      qualifications: 'MBBS BSc Hons',
      image: '/images/Dr Karan Sian.jpg',
      shortBio: 'Dr Karan Sian is a GP Registrar working toward Fellowship with the Australian College of Rural and Remote Medicine. He has over 15 years\' experience as a medical professional.',
      fullBio: 'Dr Karan Sian is a GP Registrar working toward Fellowship with the Australian College of Rural and Remote Medicine. Dr Karan has over 15 years\' experience as a medical professional. He has extensive experience in the fields of intensive care, emergency and surgery. His well-honed surgical skills coupled with a keen interest in skin cancer surgery provide all-round surgical care at the practice.',
      languages: ['English'],
      specialInterests: ['Intensive Care', 'Emergency Medicine', 'Surgery', 'Skin Cancer Surgery'],
      availability: 'Monday to Friday'
    },
    {
      id: 'dr-tasnuba-mir',
      name: 'Dr. Tasnuba Mir',
      specialty: 'Gp Registrar',
      qualifications: 'MBBS, AMC',
      image: '/images/Tasnuba.jpg',
      shortBio: 'Dr. Tasnuba Mir is a dedicated General Practitioner with 7 years of experience in providing comprehensive general practitioners services.',
      fullBio: 'Dr. Tasnuba Mir is a dedicated General Practitioner with 7 years of experience in providing comprehensive general practitioners services. She completed her medical degree and has been committed to delivering patient-centered care throughout her career. Dr. Mir has a particular interest in women\'s health, preventive medicine, and chronic disease management. She is known for her compassionate approach and takes time to listen to her patients\' concerns, ensuring they receive personalized care tailored to their individual needs.',
      languages: ['English', 'Bengali'],
      specialInterests: ['Women\'s Health', 'Preventive Medicine', 'Chronic Disease Management', 'Family Medicine'],
      availability: 'Maternity leave'
    },
    {
      id: 'dr-ahmed-elakabawey',
      name: 'Dr. Ahmed Elakabawey',
      specialty: 'General Practitioner',
      qualifications: 'GP, FRACGP',
      image: '/images/dr-ahmed-al-akabawy .jpg',
      shortBio: 'Dr Ahmed Elakabawey is a fully qualified and experienced General Practitioner holding Fellowship with the Royal Australian College of General Practitioners (FRACGP).',
      fullBio: 'Dr Ahmed Elakabawey is a fully qualified and experienced General Practitioner holding Fellowship with the Royal Australian College of General Practitioners (FRACGP). He provides comprehensive care for patients of all ages, with expertise in preventive health, chronic disease management, and acute care. Known for his approachable manner and patient-centred approach, Dr Elakabawey is committed to delivering evidence-based, compassionate general practitioners.',
      languages: ['English', 'Arabic'],
      specialInterests: ['Preventive Health', 'Chronic Disease Management', 'Acute Care', 'Patient-Centred Care'],
      availability: 'Telehealth only'
    },
    {
      id: 'dr-patrick-corcoran',
      name: 'Dr. Patrick Corcoran',
      specialty: 'GP Registrar',
      qualifications: 'ACRRM Registrar (Australian College of Rural and Remote Medicine)',
      image: '/images/dr-patrick-corcoran.jpeg',
      shortBio: 'Dr Patrick is a Registrar with the Australian College of Rural and Remote Medicine (ACRRM). He has a passion for Rural Health and Community focus. Currently accepting new patients.',
      fullBio: 'Dr Patrick is a Registrar with the Australian College of Rural and Remote Medicine (ACRRM). He has a passion for Rural Health and Community focus. Having completed Internship and Residency in the Hunter New England Region, he has returned to continue and expand his training as a Rural Generalist.',
      languages: ['English'],
      specialInterests: ['Sports Medicine and Concussion Management', 'Indigenous Health', 'Emergency Medicine', 'Rural and Regional Retrieval Medicine'],
      availability: 'Accepting new patients'
    },
    {
      id: 'dr-asma-ahsan',
      name: 'Dr. Asma Ahsan',
      specialty: 'General Practitioner',
      qualifications: 'MBBS, AMC, MRCP, Diploma in Paediatrics',
      image: '/images/dr-asma-ahsan.jpg',
      shortBio: 'Dr Asma Ahsan is an experienced General Practitioner with a diverse clinical background spanning hospital medicine, emergency care, and community-based general practice.',
      fullBio: 'Dr Asma Ahsan is an experienced General Practitioner with a diverse clinical background spanning hospital medicine, emergency care, and community-based general practice. Prior to transitioning into general practice, Dr Ahsan worked across several major hospitals within the Sydney and Hunter New England health networks, including Belmont Hospital and John Hunter Hospital. During her hospital career, she gained extensive experience in Emergency Medicine, Respiratory Medicine, Critical Care, and General Medicine, managing a broad range of acute and complex medical presentations. This strong hospital foundation has equipped Dr Ahsan with the skills to assess and manage both acute and chronic health conditions with confidence and a patient-centred approach. Dr Ahsan now provides comprehensive general practice services to patients of all ages. In addition to her work in general practice, she has experience delivering care through telehealth services, emergency care settings, and residential aged care facilities (nursing homes), allowing her to support patients across a variety of healthcare environments. She is committed to delivering high-quality, evidence-based care and is known for her compassionate manner, thorough clinical assessments, and dedication to helping patients achieve their best possible health outcomes. Dr Ahsan enjoys building long-term relationships with her patients and believes in working collaboratively to provide personalised, holistic healthcare for individuals and families within the community.',
      languages: ['English'],
      specialInterests: [
        'Emergency and Acute Care',
        'General Medicine',
        'Respiratory Health',
        'Chronic Disease Management',
        'Preventive Health',
        'Women\'s Health',
        'Children\'s Health',
        'Mental Health',
        'Aged Care and Residential Care Medicine',
        'Telehealth Services',
        'Weight Management'
      ],
      availability: 'Accepting new patients'
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      setDoctors(mockDoctors);
      setLoading(false);
    }, 1000);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    const animatedRowsRef = new Set();

    const checkRowVisibility = () => {
      const rows = document.querySelectorAll('.doctors-row');

      rows.forEach((row, index) => {
        const rowId = `doctors-row-${index}`;

        if (!animatedRowsRef.has(rowId)) {
          const rect = row.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          const shouldAnimate = index === 0
            ? rect.top < windowHeight && rect.bottom > 0
            : rect.top < windowHeight * 0.7 && rect.bottom > 0;

          if (shouldAnimate) {
            animatedRowsRef.add(rowId);
            setAnimatedRows(prev => new Set([...prev, rowId]));

            const doctorCards = row.querySelectorAll('.doctor-card');
            doctorCards.forEach((card, cardIndex) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateX(0)';
                card.classList.add('animate-left');
              }, cardIndex * 150);
            });
          }
        }
      });
    };

    setTimeout(checkRowVisibility, 1100);

    const handleScroll = () => {
      checkRowVisibility();
    };

    window.addEventListener('scroll', handleScroll);

    const checkCtaVisibility = () => {
      if (ctaRef.current) {
        const rect = ctaRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight * 0.8 && rect.bottom > 0) {
          const children = ctaRef.current.querySelectorAll('.animate-on-scroll, .animate-left, .animate-right, .animate-scale');
          children.forEach((child, index) => {
            setTimeout(() => {
              child.classList.add('animate');
            }, index * 100);
          });
        }
      }
    };

    const handleCtaScroll = () => {
      checkCtaVisibility();
    };

    window.addEventListener('scroll', handleCtaScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleCtaScroll);
    };
  }, []);

  return (
    <div className="doctors-page">
      <Helmet>
        <title>Our Doctors | Tea Gardens GP | Medical Professionals NSW</title>
        <meta name="description" content="Meet our experienced doctors at Tea Gardens GP. Qualified medical professionals providing comprehensive healthcare services in NSW." />
        <link rel="canonical" href="https://teagardensgp.com.au/doctors" />
      </Helmet>

      <div className="page-header">
        <div className="container">
          <h1>Our Team</h1>
          <p>Meet our experienced and dedicated general practice care professionals</p>
        </div>
      </div>

      <section id="doctors" ref={doctorsRef} className="section doctors-section">
        <div className="container">
          {loading ? (
            <div className="loading-spinner">
              <div className="spinner"></div>
              <p>Loading doctors...</p>
            </div>
          ) : (
            <div className="doctors-grid">
              {(() => {
                const rows = [];
                const doctorsPerRow = windowWidth <= 768 ? 1 : 3;

                for (let i = 0; i < doctors.length; i += doctorsPerRow) {
                  const rowDoctors = doctors.slice(i, i + doctorsPerRow);
                  const rowIndex = Math.floor(i / doctorsPerRow);

                  rows.push(
                    <div
                      key={`doctors-row-${rowIndex}`}
                      id={`doctors-row-${rowIndex}`}
                      className="doctors-row"
                    >
                      {rowDoctors.map((doctor) => (
                        <div className="doctor-card" key={doctor.id} style={{ opacity: 0, transform: 'translateX(-100px)', transition: 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)' }}>
                          <div className="doctor-image">
                            <img src={doctor.image} alt={doctor.name} />
                          </div>
                          <div className="doctor-info">
                            <h3 className="doctor-name">{doctor.name}</h3>
                            <p className="doctor-specialty">
                              <FontAwesomeIcon icon={faUserMd} /> {doctor.specialty}
                            </p>
                            <p className="doctor-qualifications">
                              <FontAwesomeIcon icon={faGraduationCap} /> {doctor.qualifications}
                            </p>
                            <p className="doctor-bio">{doctor.shortBio}</p>

                            <div className="doctor-details">
                              <div className="detail-item">
                                <FontAwesomeIcon icon={faLanguage} />
                                <span>Languages: {doctor.languages.join(', ')}</span>
                              </div>
                            </div>

                            <div className="doctor-actions">
                              <Link to={`/doctors/${doctor.id}`} className="btn-primary">
                                View Profile
                              </Link>
                              <Link to="https://www.hotdoc.com.au/medical-centres/tea-gardens-NSW-2324/tea-gardens-gp/doctors" className="btn-secondary">
                                Book Appointment
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  );
                }

                return rows;
              })()}
            </div>
          )}
        </div>
      </section>

      <section id="cta" ref={ctaRef} className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="animate-on-scroll">Ready to Book an Appointment?</h2>
            <p className="animate-on-scroll animate-delay-1">Our experienced doctors are here to provide you with the best general practice care possible.</p>
            <Link to="https://www.hotdoc.com.au/medical-centres/tea-gardens-NSW-2324/tea-gardens-gp/doctors" className="btn-primary animate-on-scroll animate-delay-2">Book Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Doctors;